import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

function PolicyPage({ policy }) {
  if (!policy) {
    return null;
  }

  return (
    <div className="privacy">
      <Header />
      <main className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12 center-column content-with-background" id="content">
                  <div className="pdh-page pdh-policy-page">
                    <section className="pdh-section pdh-container">
                      <h1 className="pdh-policy-title">{policy.title}</h1>
                      <div className="pdh-policy-layout">
                        <div className="pdh-policy-main">
                          <div className="pdh-policy-intro-box">
                            <p>{policy.intro}</p>
                          </div>
                          <div className="pdh-policy-sections">
                            {policy.sections.map((section, index) => (
                              <div className="pdh-policy-section" key={section.title}>
                                <ol start={index + 1}>
                                  <li className="pdh-policy-section-title">{section.title}</li>
                                </ol>
                                <div className="pdh-policy-section-content">
                                  {section.paragraphs.map((paragraph) => (
                                    <p className="pdh-policy-text" key={paragraph}>
                                      {paragraph}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="pdh-policy-footer">
                            <p className="pdh-policy-last-updated">
                              Last updated: October 16, 2026 · Questions: {" "}
                              <a className="pdh-policy-link" href="mailto:many@pawluna.art">
                                many@pawluna.art
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PolicyPage;
